import classNames from "classnames"
import MapMarinaSearchCard from "legacy/map/MapMarinaSearchCard"
import PropTypes from "prop-types"
import React from "react"

/**
 * MapMarinaList iterates through a list of marinas and calls the MapMarinaCard component
 * @param {object} state - The state passed from parent component
 * @param {array} state.marinas - List of marinas
 * @param {integer} state.marinas[].review_count - represents the number of review a marina has
 * @param {integer} state.marinas[].rating - represents the rating of the marina
 * @param {string} state.marinas[].dock_display_text - dock_display_text field of the marina
 * @param {string} state.marinas[].mooring_display_text - mooring_display_text field of the marina
 * @param {string} state.marinas[].temporary_display_text - temporary_display_text field of the marina
 * @param {array} state.marinas[].boatus_discounts - boatus_discounts field of the marina
 * @param {boolean} state.marinas[].has_dockwa_deal - has_dockwa_deal field of the marina
 * @param {array} state.marinas[].image_urls - image_urls field of the marina
 * @param {string} state.marinas[].id - id field of the marina
 * @param {string} state.marinas[].slug - slug field of the marina
 * @param {string} state.marinas[].name - name field of the marina
 * @param {string} state.marinas[].city - city field of the marina
 * @param {string} state.marinas[].state - state field of the marina
 * @param {string} state.marinas[].country - country field of the marina
 * @param {string} state.marinas[].mcom_id - mcom_id field of the marina
 * @param {boolean} state.firstLoad - Indicates whether or not the map is loading
 * @param {array} state.total_marinas - List of marinas returned by search that are visible on the map
 * @param {string} state.searchId - Unique id associated with current search results, used for amplitude
 * @param {string} state.searchTerm - Search term input by user
 * @param {string} state.focusedMarina - Id of the currently focused marina
 * @param {boolean} state.processing - Indicates whether or not a marina search is happening and indicates whether or not location is being fetched from auto complete
 */

/**
 * Function called when marina is focused
 * @callback  hoverMarina
 * @param {string} id - id of marina
 */

/**
 * Function called when marina is blurred
 * @callback   blurMarina
 */
class MapMarinaList extends React.Component {
  renderMarinaCards() {
    const marinas = this.props.state.marinas

    if (marinas.length === 0) {
      return (
        <div className="alert alert-warning col-span-12">
          <strong>No Marinas Found.</strong> Move the map, search, or adjust
          your filters to find marinas.
        </div>
      )
    }
    return marinas.map((marina, index) => (
      <MapMarinaSearchCard
        key={marina.id}
        marina={marina}
        searchId={this.props.state.searchId}
        searchTerm={this.props.state.searchTerm}
        experienceName={"search"}
        cardPosition={index}
        hoverMarina={this.props.hoverMarina}
        blurMarina={this.props.blurMarina}
        selected={this.props.state.focusedMarina === marina.id}
      />
    ))
  }

  render() {
    const marinas = this.props.state.marinas
    return (
      <div className="grid grid-cols-12 gap-4 p-2">
        <div
          className={classNames("loading-cover col-span-12", {
            "show-cover": this.props.state.processing,
          })}
        />
        {marinas.length < this.props.state.total_marinas && (
          <div className="alert alert-warning col-span-12">
            Showing {marinas.length} of {this.props.state.total_marinas}{" "}
            marinas. Zoom in to view more.
          </div>
        )}
        {this.renderMarinaCards()}
      </div>
    )
  }
}

MapMarinaList.propTypes = {
  state: PropTypes.shape({
    marinas: PropTypes.arrayOf(
      PropTypes.shape({
        review_count: PropTypes.number,
        rating: PropTypes.number,
        dock_display_text: PropTypes.string,
        mooring_display_text: PropTypes.string,
        temporary_display_text: PropTypes.string,
        boatus_discounts: PropTypes.array,
        has_dockwa_deal: PropTypes.bool,
        image_urls: PropTypes.arrayOf(PropTypes.string),
        id: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        country: PropTypes.string.isRequired,
        mcom_id: PropTypes.string.isRequired,
      })
    ).isRequired,
    firstLoad: PropTypes.bool.isRequired,
    total_marinas: PropTypes.number,
    searchId: PropTypes.string,
    searchTerm: PropTypes.string,
    focusedMarina: PropTypes.string,
    processing: PropTypes.bool.isRequired,
  }).isRequired,
  hoverMarina: PropTypes.func.isRequired,
  blurMarina: PropTypes.func.isRequired,
}

export default MapMarinaList
